module.exports = __webpack_public_path__ + "static/media/default-background.5b857e31.jpg";